import { useEffect, useState } from 'react';

/**
 * A value that changes at the top of every minute.
 *
 * Ticking once a second would repaint sixty times for fifty-nine identical
 * readings, so the timer is set to the next minute boundary each time and
 * re-armed. It also listens for a time zone change, which moves the clock
 * without a minute having passed.
 */
export function useMinuteTick(): number {
  const [tick, setTick] = useState(() => Date.now());

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const schedule = () => {
      const msToNextMinute = 60_000 - (Date.now() % 60_000);
      timer = setTimeout(() => {
        setTick(Date.now());
        schedule();
      }, msToNextMinute + 50);
    };

    schedule();

    const onZoneChange = () => setTick(Date.now());
    window.addEventListener('td:timezone', onZoneChange);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('td:timezone', onZoneChange);
    };
  }, []);

  return tick;
}
